import React, { useEffect, useState } from "react";
import {
  getFriendRequests,
  sendFriendRequestResponse,
} from "../../../../components/Shared/Utils/index.js";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import "./PendingFriendRequests.css"; // Import your CSS file

const PendingFriendRequests = ({
  accessToken,
  setDisplayError,
  setSnackBarDisplayMessage,
  setSnackBarDisplaySeveritye,
}) => {
  const [friendRequests, setFriendRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false); // State to handle collapse

  const handleGetRequests = async () => {
    setLoading(true);
    try {
      const result = await getFriendRequests(accessToken);
      if (result === null) {
        // No error, load from localStorage
        const savedRequests =
          JSON.parse(localStorage.getItem("pendingFriendRequests")) || [];
        setFriendRequests(savedRequests);
      } else {
        // Error occurred
        setDisplayError(result);
        setFriendRequests([]);
      }
    } catch (error) {
      console.error("Failed to fetch friend requests:", error);
      setDisplayError("Failed to fetch friend requests");
      setFriendRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetRequests();
  }, [accessToken]);

  const handleResponse = async (requestId, responseAction) => {
    await sendFriendRequestResponse(
      accessToken,
      responseAction,
      requestId,
      setDisplayError
      // setSnackBarDisplayMessage,
      // setSnackBarDisplaySeveritye
    );
    // Optionally reload requests after response
    handleGetRequests();
  };

  // Filter to include only pending requests
  const pendingRequests = friendRequests.filter(
    (request) => request.status === "pending"
  );

  const numberOfRequests = pendingRequests.length || "0";

  return (
    <div className="friendRequests">
      <List>
        <ListItemButton onClick={() => setOpen(!open)} style={{ padding: 0 }}>
          <ListItemText primary={`Requests ${`(${numberOfRequests})`}`} />
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {numberOfRequests === "0" ? (
              <ListItemButton sx={{ pl: 0 }}>
                <ListItemText primary="no pending friend requests" />
              </ListItemButton>
            ) : (
              pendingRequests.map((request, index) => (
                <ListItemButton
                  key={index}
                  sx={{ pl: 1, borderBottom: "var(--border)" }}
                  className="request-item"
                >
                  <ListItemText primary={request.sender.username} />
                  <ListItemIcon
                    className="hover-icons person-add-icon"
                    onClick={() => handleResponse(request._id, "accept")}
                  >
                    <PersonAddAlt1Icon />
                  </ListItemIcon>
                  <ListItemIcon
                    className="hover-icons person-remove-icon"
                    onClick={() => handleResponse(request._id, "reject")}
                  >
                    <PersonRemoveIcon />
                  </ListItemIcon>
                </ListItemButton>
              ))
            )}
          </List>
        </Collapse>
      </List>
    </div>
  );
};

export default PendingFriendRequests;
